module.exports = __webpack_public_path__ + "static/media/location-pin.e80c9c52.svg";